import React from 'react';
import { v2magenta100 } from '@paypalcorp/pp-react-colors';
import { PAYPAL_THEME } from '@paypalcorp/pp-react';
import styles from './charityLogo.less';

export default class extends React.Component {
  render() {
    const logoUrl =
      this.props.logo_url ||
      `https://${this.props.cdnHost}/paypal-ui/icons/svg/v2-causes.svg`;
    return (
      <div
        className={`npo-logo-container ${
          this.props.campaign ? `${styles['campaign-margin']}` : ''
        }`}
        style={{
          marginBottom: '24px',
        }}
      >
        <div
          className={'npo-avatar-container'}
          style={{
            backgroundColor: this.props.logo_url ? 'white' : v2magenta100,
            marginLeft: '24px',
            borderColor: PAYPAL_THEME.sysColorBackgroundMain,
            borderBottomStyle: 'solid',
          }}
        >
          <div
            className={'npo-avatar'}
            style={{
              background: `url(${logoUrl}) no-repeat center, center`,
              backgroundSize: 'contain',
              filter: this.props.logo_url
                ? ''
                : 'invert(22%) sepia(56%) saturate(2622%) hue-rotate(295deg) brightness(87%) contrast(91%)',
              maskSize: 'cover',
            }}
          />
        </div>
      </div>
    );
  }
}
